import styled from "styled-components"

import { MEDIA_SIZES } from "assets/styles/mediaSizes"

export const ContentWrapper = styled.div`
  /* Ale \`.detail-grid\` (coowe.html): minmax(0,1fr) minmax(0,1fr), gap 30px, margin-top 24px --
     ported verbatim (2026-07-03 fidelity pass). Was 1.3fr/2fr with a 15px gap, which starved the
     left column (Game plan/People/Agenda/Tasks) of width and caused the People row's Organizer
     label + "N people" text to truncate ("Orga...", "1 pe..."). */
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  column-gap: 30px;
  margin-top: 24px;
  flex-grow: 1;
  overflow-y: auto;

  @media (max-width: ${MEDIA_SIZES.TABLET_L}) {
    grid-template-columns: 1fr;
    row-gap: 15px;
  }

  /* REVIEW-PACK-FIXES (2026-07-04, QJ defect 1a): container query keyed to the ACTUAL
     .main-window width (see index.scss's \`container-type\` on .main-window), not the
     viewport -- catches the AI-panel-open squeeze the viewport-only TABLET_L media query
     above misses entirely (see index.scss comment for the full 1280x800 math). Threshold
     history: 900px was chosen so the nested Game Plan When/Where two-up split (the old
     md:grid-cols-2 geometry) kept >= ~270px per sub-column -- OBSOLETE since the
     CANONICAL-DETAIL revert made Game Plan a single-column stack (GameplanSection.tsx),
     so no sub-column constraint remains. UNION-ENFORCE-1B (2026-07-04, QJ ruling via
     coordinator): the participants' Conversation panel must stay the visible right column
     with the Coowe AI window ADDITIVE beside it -- at 1440x900 with the AI window open the
     container is ~780px, and the old 900px threshold stacked Conversation below the fold,
     making the empty AI panel read as "the conversation" (the defect QJ reported). 720px
     keeps two columns alive there (~375px each, fine for the stacked canonical left column
     and the responsive ConversationHeader) while 1280x800 + AI open (~620px container)
     still stacks, preserving the original REVIEW-PACK-FIXES crush fix intact. */
  @container teeup-shell (max-width: 720px) {
    grid-template-columns: 1fr;
    row-gap: 15px;
    /* CSS Grid "auto" row-track sizing collapsed LeftSide to 0 height here (verified live):
       LeftSide is itself \`overflow-y: auto\` with no explicit height, which per the CSS
       Sizing spec gives it an "automatic minimum size" of 0 (any non-visible overflow value
       does) instead of a content-based one -- fine in the 2-column layout where
       align-items:stretch matched it to the taller Conversation sibling, but once it owns its
       OWN row track alone, that 0-minimum let the row collapse to nothing, hiding Game
       plan/People/Agenda/Tasks entirely behind an empty first row. min-content row sizing
       forces the track to size from each item's own content instead. */
    grid-auto-rows: min-content;
  }

  @media (max-width: ${MEDIA_SIZES.MOBILE}) {
    row-gap: 10px;
    margin-top: 0;
    flex-grow: 0;
    display: flex;
    flex-direction: column;
    height: 100%;
  }
`

export const LeftSide = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  gap: 10px;

  /* GAMEPLAN-POLISH fix (2026-07-04, QJ defect: permanent thick grey scrollbar track between
     the left column and Conversation on Windows). Root cause: this container is the ONE place
     in the app that scrolls its own independent region app-wide via \`overflow-y: auto\` (the
     1280-crush fix) instead of relying on a page-level scroll -- everywhere else src/index.scss's
     global \`*::-webkit-scrollbar\` rule (8px, transparent track, #00000033 thumb) is the only
     scrollbar most users ever see, and it only shows/thickens visibly while actually scrolling
     under Chromium's overlay-scrollbar behavior. A nested, ALWAYS-non-empty overflow region like
     this one (Game plan/People/Agenda/Tasks stacked above the fold) sits tall enough on Windows
     (non-overlay/"classic" scrollbar setting, or simply a region whose content routinely exceeds
     the viewport) that the persistent 8px thumb plus its full-height track reads as a permanent
     grey bar between columns. Scoped, thinner, auto-hiding treatment (same family as the
     People strip's scrollbar-hiding CSS and the WhenWhereCard pill-strip thin scrollbar): thumb
     is transparent at rest and only appears on hover/focus, track always transparent, 6px wide
     (vs the 8px global default) so it never reads as a "thick" bar even when visible. Scrollability
     itself is untouched -- only the resting-state affordance is quieted. */
  scrollbar-width: none;
  scrollbar-color: transparent transparent;

  &:hover,
  &:focus-within {
    scrollbar-width: thin;
    scrollbar-color: #00000033 transparent;
  }

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: transparent;
    border-radius: 10px;
  }

  &:hover::-webkit-scrollbar-thumb,
  &:focus-within::-webkit-scrollbar-thumb {
    background-color: #00000033;
  }

  &::-webkit-scrollbar-thumb:hover {
    background-color: #00000055;
  }

  @media (max-width: ${MEDIA_SIZES.TABLET_L}) {
    width: 100%;
    // overflow-y: clip;
  }

  /* REVIEW-PACK-FIXES (2026-07-04): companion to ContentWrapper's teeup-shell container query
     -- once LeftSide owns a full-width row of its own (stacked, not side-by-side with
     Conversation), \`overflow-y: auto\` is what triggers the 0-height collapse (see
     ContentWrapper's comment). Letting it lay out at its natural content height here and
     leaving ContentWrapper's own overflow-y:auto as the single scroll region for the whole
     stacked column matches how the existing MOBILE breakpoint below already behaves.
     UNION-ENFORCE-1B (2026-07-04): threshold kept in lockstep with ContentWrapper's
     (900px -> 720px, see rationale there). */
  @container teeup-shell (max-width: 720px) {
    overflow-y: visible;
  }
`
